import { select, call, put } from 'redux-saga/effects';
import { logDmbErrorLocation } from '../utils/error';
import { receiveCropList } from '../actions/cropActions';
import { olConnectionV2 } from '../requesters/olConnection';
import { requestCropList } from '../requesters/cropRequester';
import { getCropListQuery } from '../queries/getCropList';
import { SPROUT_MIGRATION } from '../constants/featureFlags'
import { extractCropListFromSprout, extractCropListFromSA } from '../utils/cropData';
import { StoreCrops } from '../types';
import { AppState } from '../store/types/Store';

export const useSproutSelector = (state: AppState): boolean =>
  state.feature.userConfigFeatures[SPROUT_MIGRATION]?.value ?? false;

export function* getCropList() {
  const useSprout = yield select(useSproutSelector);

  let cropList: StoreCrops;

  try {
    if (useSprout) {
      const response = yield call(olConnectionV2, getCropListQuery());
      cropList = extractCropListFromSprout(response);
    } else {
      const response = yield call(requestCropList);
      cropList = extractCropListFromSA(response);
    }

    yield put(receiveCropList(cropList));
  } catch (error) {
    const errText = useSprout ? 'Error Fetching CROP LIST SA' : 'Error fetching CROP LIST OL';
    logDmbErrorLocation(error, errText);
  }
}
